<template>
  <div class="close-checkout">
    <div v-if="!loading && data">
      <div class="container-header">
        <ul>
          <li
            v-for="payment in data.payments"
            :key="payment.name"
            :class="{ active: payment.checkoutDrawer }"
          >
            {{ payment.name }}: <b>{{ moneyFormatBR(payment.total) }}</b>
          </li>
        </ul>
      </div>

      <div class="divider"></div>

      <div class="main">
        <ul>
          <li>
            Total de vendas R$ <b>{{ moneyFormatBR(data.total) }}</b>
          </li>

          <li class="green">
            Abertura de Caixa R$(+)
            <b>{{ moneyFormatBR(data.openCheckout.value) }}</b>
          </li>

          <li class="red tiny">
            Já lançado no caixa geral - {{ paymentUsed.join('/') }}
            <b>{{ moneyFormatBR(data.totalCheckoutNotDrawerSales) }}</b>
          </li>

          <li class="green">
            Suprimento R$(+) <b>{{ moneyFormatBR(data.suprimento) }}</b>
          </li>

          <li class="red">
            Sangria R$(-) <b>{{ moneyFormatBR(data.sangria) }}</b>
          </li>

          <li class="small">
            Total na gaveta R$(=)
            <b>{{ moneyFormatBR(data.totalCheckoutDrawer) }}</b>
          </li>

          <li class="medium">
            Total de Entrada no Caixa Geral R$(=)
            <b>{{ moneyFormatBR(data.totalCheckoutDrawerSales) }}</b>
          </li>
        </ul>

        <div class="observation">
          Notas fiscais não transmitidas também são consideradas no fechamento
          de caixa.
        </div>
      </div>
      <b-row>
        <b-col md="6" lg="6" sm="12">
          <Label for="imprimirComprovante" bold>Imprimir comprovante</Label>
          <checkbox-switch
            v-model="checkGeneratePrint"
            id="imprimirComprovante"
          />
        </b-col>
      </b-row>

      <div class="confirm-buttons">
        <Button type="error" @click="close">Cancelar</Button>
        <Button type="success" @click="handleClose">Confirmar</Button>
      </div>
    </div>

    <Loader v-if="loading" inside-component />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { orderBy } from 'lodash';
import { Loader, Button, CheckboxSwitch, Label } from '@/components';
import { DINHEIRO } from '../../../../enums/MeioPagamento';

export default {
  name: 'ModalContentCheckoutClose',
  components: {
    Loader,
    Button,
    CheckboxSwitch,
    Label,
  },
  props: {
    close: {
      type: Function,
    },
    closeCheckout: {
      type: Function,
    },
  },
  data() {
    return {
      loading: TextTrackCueList,
      checkGeneratePrint: false,
    };
  },
  methods: {
    ...mapActions('pdv', ['setGeneratePrint', 'getGeneratePrint']),
    async initModal() {
      try {
        this.data = null;
        this.loading = true;

        const checkGeneratePrint = await this.getGeneratePrint();

        this.checkGeneratePrint = !(checkGeneratePrint === '0');

        const { data } = await this.$http.post(
          'fiscal.get-checkout-current-movimentation',
        );
        this.data = {
          ...data,
          payments: orderBy(data.payments, ['checkoutDrawer'], ['asc']),
        };

        this.loading = false;
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
        this.loading = false;
      }
    },
    moneyFormatBR(value = 0) {
      return value.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
      });
    },
    async handleClose() {
      try {
        this.loading = true;

        this.setGeneratePrint(
          this.checkGeneratePrint ? this.checkGeneratePrint : 0,
        );

        const { data } = await this.$http.post('fiscal.post-close-checkout', {
          generatePrint: this.checkGeneratePrint ? this.checkGeneratePrint : 0,
        });

        if (this.closeCheckout) {
          this.closeCheckout();
        }

        if (this.close) {
          this.close();
        }

        if (data.printUrl != null) {
          const printDafe = window.open(data.printUrl, '_blank');
          printDafe.focus();
          setTimeout(() => {
            printDafe.print();
          }, 1000);
        }

        this.loading = false;
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }
    },
  },
  mounted() {
    this.initModal();
  },
  computed: {
    ...mapState('pdv', ['generatePrint']),
    paymentUsed() {
      const { paymentUsed } = this.data;
      return paymentUsed.filter((payment) => payment !== DINHEIRO);
    },
  },
  watch: {
    generatePrint(newValue) {
      this.checkGeneratePrint = newValue;
    },
  },
};
</script>
